import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=7a56d012&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&setup=true&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=7a56d012&prod&scoped=true&lang=css&"
import style1 from "./RadioGroup.vue?vue&type=style&index=1&id=7a56d012&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56d012",
  null
  
)

export default component.exports